import { createSelector } from "reselect";

const featureSelector = ({ alerts }) => alerts;

export const getAlerts = createSelector(featureSelector, (alerts) => alerts);
